import React from 'react';
import { Modal } from 'antd';
import pkg from '../../package.json';

interface Props {
  open: boolean;
  onClose: () => void;
}

const YEAR = 2026;

const AboutModal: React.FC<Props> = ({ open, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={480}
    styles={{ body: { background: '#12121f', borderRadius: 10, padding: 0 }, header: { display: 'none' }, mask: undefined }}
  >
    {/* Header band */}
    <div style={{
      background: 'linear-gradient(135deg, #1a1a32 0%, #0d0d1a 100%)',
      borderRadius: '10px 10px 0 0',
      padding: '32px 32px 24px',
      textAlign: 'center',
      borderBottom: '1px solid #2a2a40',
    }}>
      <img src="/logo512.png" alt="StoryBall" style={{ width: 72, height: 72, marginBottom: 12, borderRadius: 16 }} />
      <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: '#fff', letterSpacing: 1 }}>StoryBall</h1>
      <div style={{ marginTop: 6, fontSize: 12, color: '#555', letterSpacing: 2, textTransform: 'uppercase' }}>
        Version {pkg.version}
      </div>
    </div>

    {/* Body */}
    <div style={{ padding: '28px 32px 32px', color: '#bbb', fontSize: 13, lineHeight: 1.75 }}>
      <p style={{ marginTop: 0 }}>
        StoryBall is a 3D painting and storyboarding tool built for artists who think in
        spheres. Paint directly onto a globe with layered brushes, stamps, and text —
        then bring your composition to life with a full keyframe timeline, all inside your browser.
      </p>
      <p>
        Whether you're sketching a panoramic establishing shot, blocking out camera
        positions for a dome film, or exploring 360° narrative layout, StoryBall gives
        you the canvas to think spatially from the very first frame.
      </p>

      <div style={{
        marginTop: 20,
        padding: '14px 18px',
        background: 'rgba(255,255,255,0.04)',
        borderRadius: 7,
        border: '1px solid #2a2a40',
        fontSize: 12,
        color: '#666',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '6px 20px',
      }}>
        <span>React + Three.js</span>
        <span>WebGL paint engine</span>
        <span>Zustand state</span>
        <span>Ant Design UI</span>
        <span>React Three Fiber</span>
        <span>Tablet &amp; touch support</span>
      </div>

      <div style={{ marginTop: 24, textAlign: 'center', fontSize: 12, color: '#444' }}>
        © {YEAR} 10lbHam. Built with care for storytellers.
      </div>
    </div>
  </Modal>
);

export default AboutModal;

